import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { getLeadCustomFieldDefinitions } from "../../actionCreator/leadCustomFieldDefinitionsActionCreator";

export const useLeadCustomFieldDefinitions = () => {
  const dispatch = useDispatch();
  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(false);

  const refreshFields = async (showLoader = true) => {
    if (showLoader) {
      setLoading(true);
    }

    const res = await dispatch(getLeadCustomFieldDefinitions("sort=createdDate,desc"));
    const nextFields = Array.isArray(res) ? res : null;
    if (nextFields) {
      setFields(nextFields);
    }

    if (showLoader) {
      setLoading(false);
    }

    return nextFields || fields;
  };

  useEffect(() => {
    refreshFields();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    fields,
    loading,
    refreshFields,
  };
};
